import { apiCall, ApiConfig } from '../../config/api'
import { TypePosition } from '../../interfaces/TypePosition/TypePosition'
import { getTypePositionsAction } from '../actions/typePositionActions'
import { call, put, takeEvery } from '@redux-saga/core/effects'
import { AxiosError, AxiosResponse } from 'axios'
import { GET_TYPE_POSITION } from '../types/typePositionActionsTypes'
import { DataGridElements } from '../../interfaces/index'

export function* getTypePositionsAsync() {
  try {
    const { status, data }: AxiosResponse<DataGridElements<TypePosition>> =
      yield call(apiCall, 'GET', `${ApiConfig.TypepositionApi}?pageSize=100`)
    if (status === 200) {
      yield put(getTypePositionsAction(data.items))
    }
  } catch (error) {
    const serverError = error as AxiosError<string>
    yield put(getTypePositionsAction([], serverError.message))
  }
}

export function* watchGetTypePositionsAsync() {
  yield takeEvery(GET_TYPE_POSITION, getTypePositionsAsync)
}
